import type { HTMLAttributes } from 'react'
import { cn } from '@/app/lib/cn'

/** A raised panel. Replaces the desktop app's light-grey card. */
export function Surface({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={cn('rounded-[16px] bg-surface ring-1 ring-line', className)}
    />
  )
}
